import { render, staticRenderFns } from "./OfferListPanel.vue?vue&type=template&id=10a1acba&scoped=true&"
import script from "./OfferListPanel.vue?vue&type=script&lang=js&"
export * from "./OfferListPanel.vue?vue&type=script&lang=js&"
import style0 from "./OfferListPanel.vue?vue&type=style&index=0&id=10a1acba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a1acba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10a1acba')) {
      api.createRecord('10a1acba', component.options)
    } else {
      api.reload('10a1acba', component.options)
    }
    module.hot.accept("./OfferListPanel.vue?vue&type=template&id=10a1acba&scoped=true&", function () {
      api.rerender('10a1acba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/DispatchDashboard/components/OfferListPanel.vue"
export default component.exports